var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotsRedRandom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 118,
    viewBox: "0 0 117 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8486 35.6309C35.1684 36.7605 36.9116 33.136 34.5918 32.0064C32.1901 30.8988 30.4469 34.5232 32.8486 35.6309Z",
    fill: "#E6889F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08753 52.1055C10.4074 53.2351 12.1506 49.6107 9.83073 48.4811C7.51086 47.3515 5.76766 50.9759 8.08753 52.1055Z",
    fill: "#E6889F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9262 55.1587C35.2461 56.2883 36.9893 52.6639 34.6694 51.5343C32.3276 50.3229 30.6063 54.0291 32.9262 55.1587Z",
    fill: "#E6889F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7106 32.7521C54.0304 33.8817 55.7736 30.2573 53.4538 29.1277C51.1339 27.9981 49.3907 31.6225 51.7106 32.7521Z",
    fill: "#E6889F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61027 26.0168C10.9301 27.1464 12.6733 23.522 10.3535 22.3924C7.95185 21.2848 6.20865 24.9092 8.61027 26.0168Z",
    fill: "#E6889F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7204 62.6773C63.0403 63.8069 64.7835 60.1825 62.4636 59.0529C60.04 57.8635 58.3188 61.5697 60.7204 62.6773Z",
    fill: "#E6889F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6571 86.5791C40.977 87.7087 42.7202 84.0843 40.4003 82.9547C37.9987 81.8471 36.2555 85.4715 38.6571 86.5791Z",
    fill: "#E6889F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1039 93.9223C69.4238 95.0519 71.167 91.4275 68.8471 90.2979C66.5053 89.0865 64.7841 92.7927 67.1039 93.9223Z",
    fill: "#E6889F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8336 79.4782C93.1535 80.6078 94.8967 76.9834 92.5768 75.8538C90.257 74.7242 88.5138 78.3486 90.8336 79.4782Z",
    fill: "#E6889F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.28 66.8229C108.6 67.9526 110.343 64.3281 108.023 63.1985C105.681 61.9872 103.96 65.6933 106.28 66.8229Z",
    fill: "#E6889F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6052 81.1054C64.9251 82.235 66.6683 78.6106 64.3484 77.481C61.9248 76.2917 60.2036 79.9978 62.6052 81.1054Z",
    fill: "#E6889F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.788 98.6825C94.1079 99.8121 95.8511 96.1877 93.5312 95.0581C91.1296 93.9504 89.3864 97.5748 91.788 98.6825Z",
    fill: "#E6889F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5914 68.4914C48.9113 69.621 50.6545 65.9966 48.3346 64.867C46.0148 63.7374 44.2716 67.3618 46.5914 68.4914Z",
    fill: "#E6889F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4789 53.1523C83.7988 54.2819 85.542 50.6575 83.2221 49.5279C80.8803 48.3165 79.1591 52.0227 81.4789 53.1523Z",
    fill: "#E6889F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6239 100.707C54.9438 101.837 56.687 98.2126 54.3671 97.083C51.9655 95.9753 50.2223 99.5998 52.6239 100.707Z",
    fill: "#E6889F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.609 31.3654C70.9289 32.495 72.6721 28.8706 70.3522 27.741C68.0323 26.6114 66.2891 30.2358 68.609 31.3654Z",
    fill: "#E6889F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7138 14.1264C61.0337 15.256 62.7769 11.6316 60.457 10.502C58.0554 9.39435 56.3122 13.0188 58.7138 14.1264Z",
    fill: "#E6889F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7067 34.9801C93.0265 36.1097 94.7697 32.4853 92.4499 31.3557C90.13 30.2261 88.3868 33.8505 90.7067 34.9801Z",
    fill: "#E6889F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6176 76.0295C77.9375 77.1591 79.6807 73.5347 77.3608 72.4051C75.019 71.1937 73.2977 74.8999 75.6176 76.0295Z",
    fill: "#E6889F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2509 48.7658C49.5708 49.8955 51.314 46.271 48.9941 45.1414C46.6742 44.0118 44.8493 47.6582 47.2509 48.7658Z",
    fill: "#E6889F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1481 47.3794C66.4679 48.509 68.2112 44.8846 65.8913 43.755C63.5714 42.6254 61.8282 46.2498 64.1481 47.3794Z",
    fill: "#E6889F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsRedRandom);
export default __webpack_public_path__ + "static/media/dots-red-random.6b951ee0847e2299f44d907ae83b421b.svg";
export { ForwardRef as ReactComponent };